/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../$$_gendir/node_modules/angular2-spinner/dist/angular2-spinner.ngfactory';
import * as import2 from 'angular2-spinner/dist/angular2-spinner';
import * as import3 from '@angular/router';
import * as import4 from '@angular/common';
import * as import5 from '@ngx-translate/core/src/translate.pipe';
import * as import6 from '@ngx-translate/core/src/translate.service';
import * as import7 from '../../../app/layout/menu.component';
import * as import8 from '../../../app/services/menu.service';
import * as import9 from '../../../app/services/conversations.service';
const styles_MenuComponent:any[] = ([] as any[]);
export const RenderType_MenuComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_MenuComponent,
  data: {}
}
);
function View_MenuComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'ul',[[
        'class',
        'menu'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'spinner'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'spinner',([] as any[]),[
      [
        4,
        'width',
        'px'
      ]
      ,
      [
        4,
        'height',
        'px'
      ]
      ,
      [
        4,
        'borderWidth',
        'px'
      ]
      ,
      [
        4,
        'borderTopColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderBottomColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderLeftColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderRightColor',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),import1.View_SpinnerComponent_0,import1.RenderType_SpinnerComponent)),
    import0.ɵdid(114688,(null as any),0,import2.SpinnerComponent,([] as any[]),{
      size: [
        0,
        'size'
      ]
      ,
      tickness: [
        1,
        'tickness'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'spinner-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wczytywanie menu'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    const currVal_7:any = 35;
    const currVal_8:any = 3;
    ck(v,5,0,currVal_7,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,5).size;
    const currVal_1:any = import0.ɵnov(v,5).size;
    const currVal_2:any = import0.ɵnov(v,5).tickness;
    const currVal_3:any = import0.ɵnov(v,5).color;
    const currVal_4:any = import0.ɵnov(v,5).secondColor;
    const currVal_5:any = import0.ɵnov(v,5).secondColor;
    const currVal_6:any = import0.ɵnov(v,5).secondColor;
    ck(v,4,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_MenuComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'a',[[
        'routerLinkActive',
        'grey-link'
      ]
    ],[
      [
        8,
        'title',
        0
      ]
      ,
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,3).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        8,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵpad(3),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,7,{links: 1}),
    import0.ɵqud(603979776,8,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_3:any = ck(v,4,0,'/server/dashboard/',v.context.$implicit.contract,v.context.$implicit.service);
    ck(v,3,0,currVal_3);
    const currVal_4:any = 'grey-link';
    ck(v,5,0,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'Kontrakt: ',v.context.$implicit.contract_name,'');
    const currVal_1:any = import0.ɵnov(v,3).target;
    const currVal_2:any = import0.ɵnov(v,3).href;
    ck(v,2,0,currVal_0,currVal_1,currVal_2);
    const currVal_5:any = v.context.$implicit.name;
    ck(v,8,0,currVal_5);
  });
}
function View_MenuComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),26,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'a',[
      [
        'class',
        'trigger'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,3,{links: 1}),
    import0.ɵqud(603979776,4,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,'ul',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'placeholder',
        'Wyszukaj serwer'
      ]
      ,
      [
        'style',
        'width: 100% !important'
      ]
      ,
      [
        'type',
        'text'
      ]
      ,
      [
        'value',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'keyup'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('keyup' === en)) {
        const pd_0:any = ((<any>co.search($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'a',[
      [
        'routerLink',
        '/server/list'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,16).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        6,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,5,{links: 1}),
    import0.ɵqud(603979776,6,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),['Wszystkie serwery'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_4)),
    import0.ɵdid(802816,(null as any),0,import4.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'grey-link';
    ck(v,3,0,currVal_0);
    const currVal_4:any = '/server/list';
    ck(v,16,0,currVal_4);
    const currVal_5:any = 'grey-link';
    ck(v,17,0,currVal_5);
    const currVal_6:any = co.filteredServers;
    ck(v,24,0,currVal_6);
  },(ck,v) => {
    const currVal_1:any = import0.ɵunv(v,6,0,import0.ɵnov(v,7).transform('SERVERS.SERVERS'));
    ck(v,6,0,currVal_1);
    const currVal_2:any = import0.ɵnov(v,16).target;
    const currVal_3:any = import0.ɵnov(v,16).href;
    ck(v,15,0,currVal_2,currVal_3);
  });
}
function View_MenuComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'a',[[
        'routerLinkActive',
        'grey-link'
      ]
    ],[
      [
        8,
        'title',
        0
      ]
      ,
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,3).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        14,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵpad(3),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,13,{links: 1}),
    import0.ɵqud(603979776,14,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '\n                                    └─',
      '\n                            '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                        ']))
  ]
  ,(ck,v) => {
    const currVal_3:any = ck(v,4,0,'/server/dashboard/',v.context.$implicit.contract,v.context.$implicit.service);
    ck(v,3,0,currVal_3);
    const currVal_4:any = 'grey-link';
    ck(v,5,0,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'Kontrakt: ',v.context.$implicit.name,'');
    const currVal_1:any = import0.ɵnov(v,3).target;
    const currVal_2:any = import0.ɵnov(v,3).href;
    ck(v,2,0,currVal_0,currVal_1,currVal_2);
    const currVal_5:any = v.context.$implicit.name;
    ck(v,8,0,currVal_5);
  });
}
function View_MenuComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),12,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'a',[[
        'routerLinkActive',
        'grey-link'
      ]
    ],[
      [
        8,
        'title',
        0
      ]
      ,
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,3).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        12,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵpad(2),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,11,{links: 1}),
    import0.ɵqud(603979776,12,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_7)),
    import0.ɵdid(802816,(null as any),0,import4.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_3:any = ck(v,4,0,'/cloud/',v.context.$implicit.uuid);
    ck(v,3,0,currVal_3);
    const currVal_4:any = 'grey-link';
    ck(v,5,0,currVal_4);
    const currVal_6:any = v.context.$implicit.servers;
    ck(v,11,0,currVal_6);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'Chmura prywatna: ',v.context.$implicit.name,'');
    const currVal_1:any = import0.ɵnov(v,3).target;
    const currVal_2:any = import0.ɵnov(v,3).href;
    ck(v,2,0,currVal_0,currVal_1,currVal_2);
    const currVal_5:any = v.context.$implicit.name;
    ck(v,8,0,currVal_5);
  });
}
function View_MenuComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'a',[
      [
        'class',
        'trigger'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,9,{links: 1}),
    import0.ɵqud(603979776,10,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'ul',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'placeholder',
        'Wyszukaj chmurę'
      ]
      ,
      [
        'style',
        'width: 100% !important'
      ]
      ,
      [
        'type',
        'text'
      ]
      ,
      [
        'value',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'keyup'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('keyup' === en)) {
        const pd_0:any = ((<any>co.searchClouds($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_6)),
    import0.ɵdid(802816,(null as any),0,import4.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'grey-link';
    ck(v,3,0,currVal_0);
    const currVal_2:any = co.filteredClouds;
    ck(v,14,0,currVal_2);
  },(ck,v) => {
    const currVal_1:any = import0.ɵunv(v,6,0,import0.ɵnov(v,7).transform('CLOUD.CLOUD'));
    ck(v,6,0,currVal_1);
  });
}
function View_MenuComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'a',[[
        'routerLinkActive',
        'grey-link'
      ]
    ],[
      [
        8,
        'title',
        0
      ]
      ,
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,3).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        18,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵpad(2),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,17,{links: 1}),
    import0.ɵqud(603979776,18,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_3:any = ck(v,4,0,'/vm/',v.context.$implicit.uuid);
    ck(v,3,0,currVal_3);
    const currVal_4:any = 'grey-link';
    ck(v,5,0,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'Cloud.VPS: ',v.context.$implicit.name,'');
    const currVal_1:any = import0.ɵnov(v,3).target;
    const currVal_2:any = import0.ɵnov(v,3).href;
    ck(v,2,0,currVal_0,currVal_1,currVal_2);
    const currVal_5:any = v.context.$implicit.name;
    ck(v,8,0,currVal_5);
  });
}
function View_MenuComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'a',[
      [
        'class',
        'trigger'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,15,{links: 1}),
    import0.ɵqud(603979776,16,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'ul',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'placeholder',
        'Wyszukaj Cloud.VPS'
      ]
      ,
      [
        'style',
        'width: 100% !important'
      ]
      ,
      [
        'type',
        'text'
      ]
      ,
      [
        'value',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'keyup'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('keyup' === en)) {
        const pd_0:any = ((<any>co.searchCloudVPS($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_9)),
    import0.ɵdid(802816,(null as any),0,import4.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'grey-link';
    ck(v,3,0,currVal_0);
    const currVal_2:any = co.filteredCloudvps;
    ck(v,14,0,currVal_2);
  },(ck,v) => {
    const currVal_1:any = import0.ɵunv(v,6,0,import0.ɵnov(v,7).transform('CLOUD.VPS'));
    ck(v,6,0,currVal_1);
  });
}
function View_MenuComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'a',[[
        'routerLinkActive',
        'grey-link'
      ]
    ],[
      [
        8,
        'title',
        0
      ]
      ,
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,3).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        22,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵpad(3),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,21,{links: 1}),
    import0.ɵqud(603979776,22,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_3:any = ck(v,4,0,'/server/dashboard/',v.context.$implicit.contract,v.context.$implicit.service);
    ck(v,3,0,currVal_3);
    const currVal_4:any = 'grey-link';
    ck(v,5,0,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'Kontrakt: ',v.context.$implicit.contract_name,'');
    const currVal_1:any = import0.ɵnov(v,3).target;
    const currVal_2:any = import0.ɵnov(v,3).href;
    ck(v,2,0,currVal_0,currVal_1,currVal_2);
    const currVal_5:any = v.context.$implicit.name;
    ck(v,8,0,currVal_5);
  });
}
function View_MenuComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'a',[
      [
        'class',
        'trigger'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,19,{links: 1}),
    import0.ɵqud(603979776,20,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'ul',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'placeholder',
        'Wyszukaj serwer kolokacyjny'
      ]
      ,
      [
        'style',
        'width: 100% !important'
      ]
      ,
      [
        'type',
        'text'
      ]
      ,
      [
        'value',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'keyup'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('keyup' === en)) {
        const pd_0:any = ((<any>co.searchServersColocated($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    \n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_11)),
    import0.ɵdid(802816,(null as any),0,import4.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'grey-link';
    ck(v,3,0,currVal_0);
    const currVal_2:any = co.filteredServersColocated;
    ck(v,14,0,currVal_2);
  },(ck,v) => {
    const currVal_1:any = import0.ɵunv(v,6,0,import0.ɵnov(v,7).transform('SERVERS.COLOCATED'));
    ck(v,6,0,currVal_1);
  });
}
function View_MenuComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'a',[[
        'routerLinkActive',
        'grey-link'
      ]
    ],[
      [
        8,
        'title',
        0
      ]
      ,
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,3).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        26,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵpad(2),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,25,{links: 1}),
    import0.ɵqud(603979776,26,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_3:any = ck(v,4,0,'/backupftp/',v.context.$implicit.uuid);
    ck(v,3,0,currVal_3);
    const currVal_4:any = 'grey-link';
    ck(v,5,0,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'Backup FTP: ',v.context.$implicit.domain,'');
    const currVal_1:any = import0.ɵnov(v,3).target;
    const currVal_2:any = import0.ɵnov(v,3).href;
    ck(v,2,0,currVal_0,currVal_1,currVal_2);
    const currVal_5:any = v.context.$implicit.name;
    ck(v,8,0,currVal_5);
  });
}
function View_MenuComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'a',[
      [
        'class',
        'trigger'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,23,{links: 1}),
    import0.ɵqud(603979776,24,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'ul',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'placeholder',
        'Wyszukaj backup FTP'
      ]
      ,
      [
        'style',
        'width: 100% !important'
      ]
      ,
      [
        'type',
        'text'
      ]
      ,
      [
        'value',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'keyup'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('keyup' === en)) {
        const pd_0:any = ((<any>co.searchBackupFtps($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_13)),
    import0.ɵdid(802816,(null as any),0,import4.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'grey-link';
    ck(v,3,0,currVal_0);
    const currVal_2:any = co.filteredBackupftps;
    ck(v,14,0,currVal_2);
  },(ck,v) => {
    const currVal_1:any = import0.ɵunv(v,6,0,import0.ɵnov(v,7).transform('BACKUPFTP.BACKUPFTP'));
    ck(v,6,0,currVal_1);
  });
}
function View_MenuComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'a',[[
        'routerLinkActive',
        'grey-link'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,3).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        32,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵpad(2),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,31,{links: 1}),
    import0.ɵqud(603979776,32,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_2:any = ck(v,4,0,'/contracts/details/',v.context.$implicit.contract);
    ck(v,3,0,currVal_2);
    const currVal_3:any = 'grey-link';
    ck(v,5,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,3).target;
    const currVal_1:any = import0.ɵnov(v,3).href;
    ck(v,2,0,currVal_0,currVal_1);
    const currVal_4:any = v.context.$implicit.name;
    ck(v,8,0,currVal_4);
  });
}
function View_MenuComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),27,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'a',[
      [
        'class',
        'trigger'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,27,{links: 1}),
    import0.ɵqud(603979776,28,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),17,'ul',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'placeholder',
        'Wyszukaj kontrakt'
      ]
      ,
      [
        'style',
        'width: 100% !important'
      ]
      ,
      [
        'type',
        'text'
      ]
      ,
      [
        'value',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'keyup'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('keyup' === en)) {
        const pd_0:any = ((<any>co.searchContract($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'a',[
      [
        'routerLink',
        '/contracts/list'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,16).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        30,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,29,{links: 1}),
    import0.ɵqud(603979776,30,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_15)),
    import0.ɵdid(802816,(null as any),0,import4.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'grey-link';
    ck(v,3,0,currVal_0);
    const currVal_4:any = '/contracts/list';
    ck(v,16,0,currVal_4);
    const currVal_5:any = 'grey-link';
    ck(v,17,0,currVal_5);
    const currVal_7:any = co.filteredContracts;
    ck(v,25,0,currVal_7);
  },(ck,v) => {
    const currVal_1:any = import0.ɵunv(v,6,0,import0.ɵnov(v,7).transform('CONTRACTS.CONTRACTS'));
    ck(v,6,0,currVal_1);
    const currVal_2:any = import0.ɵnov(v,16).target;
    const currVal_3:any = import0.ɵnov(v,16).href;
    ck(v,15,0,currVal_2,currVal_3);
    const currVal_6:any = import0.ɵunv(v,20,0,import0.ɵnov(v,21).transform('CONTRACTS.ALL'));
    ck(v,20,0,currVal_6);
  });
}
function View_MenuComponent_17(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'a',[[
        'routerLinkActive',
        'grey-link'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,3).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        38,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵpad(2),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,37,{links: 1}),
    import0.ɵqud(603979776,38,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_2:any = ck(v,4,0,'/domains/details/',v.context.$implicit.id);
    ck(v,3,0,currVal_2);
    const currVal_3:any = 'grey-link';
    ck(v,5,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,3).target;
    const currVal_1:any = import0.ɵnov(v,3).href;
    ck(v,2,0,currVal_0,currVal_1);
    const currVal_4:any = v.context.$implicit.name;
    ck(v,8,0,currVal_4);
  });
}
function View_MenuComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),27,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'a',[
      [
        'class',
        'trigger'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,33,{links: 1}),
    import0.ɵqud(603979776,34,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),17,'ul',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'placeholder',
        'Wyszukaj domeny'
      ]
      ,
      [
        'style',
        'width:100% !important'
      ]
      ,
      [
        'type',
        'text'
      ]
      ,
      [
        'value',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'keyup'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('keyup' === en)) {
        const pd_0:any = ((<any>co.searchDomains($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'a',[
      [
        'routerLink',
        '/domains/list'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,16).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        36,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,35,{links: 1}),
    import0.ɵqud(603979776,36,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_17)),
    import0.ɵdid(802816,(null as any),0,import4.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'grey-link';
    ck(v,3,0,currVal_0);
    const currVal_4:any = '/domains/list';
    ck(v,16,0,currVal_4);
    const currVal_5:any = 'grey-link';
    ck(v,17,0,currVal_5);
    const currVal_7:any = co.filteredDomains;
    ck(v,25,0,currVal_7);
  },(ck,v) => {
    const currVal_1:any = import0.ɵunv(v,6,0,import0.ɵnov(v,7).transform('DOMAINS.DOMAINS'));
    ck(v,6,0,currVal_1);
    const currVal_2:any = import0.ɵnov(v,16).target;
    const currVal_3:any = import0.ɵnov(v,16).href;
    ck(v,15,0,currVal_2,currVal_3);
    const currVal_6:any = import0.ɵunv(v,20,0,import0.ɵnov(v,21).transform('DOMAINS.ALL'));
    ck(v,20,0,currVal_6);
  });
}
function View_MenuComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),123,'ul',[[
        'class',
        'menu'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'a',[
      [
        'routerLink',
        '/panel'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,5).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        2,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,1,{links: 1}),
    import0.ɵqud(603979776,2,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_3)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_5)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_8)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_10)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_12)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_14)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_16)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'a',[
      [
        'routerLink',
        '/messages/list'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,37).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        40,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,39,{links: 1}),
    import0.ɵqud(603979776,40,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '',
      '\n                    '
    ]
    )),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'a',[
      [
        'routerLink',
        '/payments/list'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,49).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        42,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,41,{links: 1}),
    import0.ɵqud(603979776,42,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import5.TranslatePipe,[
      import6.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'a',[
      [
        'routerLink',
        '/cart/list'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,60).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        44,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,43,{links: 1}),
    import0.ɵqud(603979776,44,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),['Koszyki zakupowe'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[' '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'a',[
      [
        'routerLink',
        '/news/list'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,70).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        46,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,45,{links: 1}),
    import0.ɵqud(603979776,46,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),[' Aktualności'])),
    (l()(),import0.ɵted((null as any),[' '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'a',[
      [
        'routerLink',
        '/company/edit'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,80).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        48,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,47,{links: 1}),
    import0.ɵqud(603979776,48,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),['Dane firmy'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'a',[[
        'routerLink',
        '/account/logons'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,90).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['Logowania na konto'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'a',[
      [
        'routerLink',
        '/checkout/select'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,97).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        50,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,49,{links: 1}),
    import0.ɵqud(603979776,50,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),['KUP SERWER'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'a',[
      [
        'routerLink',
        '/checkout/vm'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,107).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        52,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,51,{links: 1}),
    import0.ɵqud(603979776,52,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),['KUP Cloud.VPS'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'a',[
      [
        'routerLink',
        '/service/offer'
      ]
      ,
      [
        'routerLinkActive',
        'grey-link'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,117).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import0.ɵdid(671744,[[
        54,
        4
      ]
    ],0,import3.RouterLinkWithHref,[
      import3.Router,
      import3.ActivatedRoute,
      import4.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import0.ɵdid(1720320,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import0.ElementRef,
      import0.Renderer,
      import0.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import0.ɵqud(603979776,53,{links: 1}),
    import0.ɵqud(603979776,54,{linksWithHrefs: 1}),
    (l()(),import0.ɵted((null as any),['KUP USŁUGI'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = '/panel';
    ck(v,5,0,currVal_2);
    const currVal_3:any = 'grey-link';
    ck(v,6,0,currVal_3);
    const currVal_5:any = (co.servers && co.servers.length);
    ck(v,14,0,currVal_5);
    const currVal_6:any = (co.clouds && co.clouds.length);
    ck(v,17,0,currVal_6);
    const currVal_7:any = (co.cloudvps && co.cloudvps.length);
    ck(v,20,0,currVal_7);
    const currVal_8:any = (co.serversColocated && co.serversColocated.length);
    ck(v,23,0,currVal_8);
    const currVal_9:any = (co.backupftps && co.backupftps.length);
    ck(v,26,0,currVal_9);
    const currVal_10:any = (co.contracts && co.contracts.length);
    ck(v,29,0,currVal_10);
    const currVal_11:any = (co.domains && co.domains.length);
    ck(v,32,0,currVal_11);
    const currVal_14:any = '/messages/list';
    ck(v,37,0,currVal_14);
    const currVal_15:any = 'grey-link';
    ck(v,38,0,currVal_15);
    const currVal_19:any = '/payments/list';
    ck(v,49,0,currVal_19);
    const currVal_20:any = 'grey-link';
    ck(v,50,0,currVal_20);
    const currVal_24:any = '/cart/list';
    ck(v,60,0,currVal_24);
    const currVal_25:any = 'grey-link';
    ck(v,61,0,currVal_25);
    const currVal_28:any = '/news/list';
    ck(v,70,0,currVal_28);
    const currVal_29:any = 'grey-link';
    ck(v,71,0,currVal_29);
    const currVal_32:any = '/company/edit';
    ck(v,80,0,currVal_32);
    const currVal_33:any = 'grey-link';
    ck(v,81,0,currVal_33);
    const currVal_36:any = '/account/logons';
    ck(v,90,0,currVal_36);
    const currVal_39:any = '/checkout/select';
    ck(v,97,0,currVal_39);
    const currVal_40:any = 'grey-link';
    ck(v,98,0,currVal_40);
    const currVal_43:any = '/checkout/vm';
    ck(v,107,0,currVal_43);
    const currVal_44:any = 'grey-link';
    ck(v,108,0,currVal_44);
    const currVal_47:any = '/service/offer';
    ck(v,117,0,currVal_47);
    const currVal_48:any = 'grey-link';
    ck(v,118,0,currVal_48);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,5).target;
    const currVal_1:any = import0.ɵnov(v,5).href;
    ck(v,4,0,currVal_0,currVal_1);
    const currVal_4:any = import0.ɵunv(v,9,0,import0.ɵnov(v,10).transform('GENERAL.COCPIT'));
    ck(v,9,0,currVal_4);
    const currVal_12:any = import0.ɵnov(v,37).target;
    const currVal_13:any = import0.ɵnov(v,37).href;
    ck(v,36,0,currVal_12,currVal_13);
    const currVal_16:any = import0.ɵunv(v,41,0,import0.ɵnov(v,42).transform('MESSAGES.MESSAGES'));
    ck(v,41,0,currVal_16);
    const currVal_17:any = import0.ɵnov(v,49).target;
    const currVal_18:any = import0.ɵnov(v,49).href;
    ck(v,48,0,currVal_17,currVal_18);
    const currVal_21:any = import0.ɵunv(v,53,0,import0.ɵnov(v,54).transform('INVOICESANDPAYMENTS.INVOICESANDPAYMENTS'));
    ck(v,53,0,currVal_21);
    const currVal_22:any = import0.ɵnov(v,60).target;
    const currVal_23:any = import0.ɵnov(v,60).href;
    ck(v,59,0,currVal_22,currVal_23);
    const currVal_26:any = import0.ɵnov(v,70).target;
    const currVal_27:any = import0.ɵnov(v,70).href;
    ck(v,69,0,currVal_26,currVal_27);
    const currVal_30:any = import0.ɵnov(v,80).target;
    const currVal_31:any = import0.ɵnov(v,80).href;
    ck(v,79,0,currVal_30,currVal_31);
    const currVal_34:any = import0.ɵnov(v,90).target;
    const currVal_35:any = import0.ɵnov(v,90).href;
    ck(v,89,0,currVal_34,currVal_35);
    const currVal_37:any = import0.ɵnov(v,97).target;
    const currVal_38:any = import0.ɵnov(v,97).href;
    ck(v,96,0,currVal_37,currVal_38);
    const currVal_41:any = import0.ɵnov(v,107).target;
    const currVal_42:any = import0.ɵnov(v,107).href;
    ck(v,106,0,currVal_41,currVal_42);
    const currVal_45:any = import0.ɵnov(v,117).target;
    const currVal_46:any = import0.ɵnov(v,117).href;
    ck(v,116,0,currVal_45,currVal_46);
  });
}
export function View_MenuComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),19,'aside',[[
        'class',
        'sidebar'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'nav',[[
        'class',
        'container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'mobile-menu'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[
      [
        'class',
        'menu-trigger'
      ]
      ,
      [
        'href',
        '#'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['MENU'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_1)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_2)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'version'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wersja: 1.5.0'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import7.MenuComponent = v.component;
    const currVal_0:any = co.loadingMenu;
    ck(v,11,0,currVal_0);
    const currVal_1:boolean = !co.loadingMenu;
    ck(v,14,0,currVal_1);
  },(null as any));
}
function View_MenuComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-menu',([] as any[]),(null as any),(null as any),(null as any),View_MenuComponent_0,RenderType_MenuComponent)),
    import0.ɵdid(2211840,(null as any),0,import7.MenuComponent,[
      import8.MenuService,
      import9.ConversationsService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const MenuComponentNgFactory:import0.ComponentFactory<import7.MenuComponent> = import0.ɵccf('app-menu',import7.MenuComponent,View_MenuComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/layout/menu.component.ngfactory.ts